import { render, staticRenderFns } from "./FormErrorItem.vue?vue&type=template&id=0158b1ea&"
import script from "./FormErrorItem.vue?vue&type=script&lang=js&"
export * from "./FormErrorItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports